import * as Yup from "yup";

const BusinessNameSchema = Yup.object().shape({
  descripcion: Yup.string().required("Nombre de Razon Social es requerido"),
});

export default BusinessNameSchema;
